module.exports = __webpack_public_path__ + "images/img-1OcK-dA.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/50.jpg
// module id = 2019
// module chunks = 0